import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  key: 0,
  class: "form-control"
}
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  key: 0,
  class: "form-control"
}
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = {
  key: 0,
  class: "form-control"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-sm-6" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = {
  key: 0,
  class: "form-control"
}
const _hoisted_15 = { class: "col-sm-6" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = {
  key: 0,
  class: "row"
}
const _hoisted_18 = { class: "form-group col-md-4" }
const _hoisted_19 = {
  key: 0,
  class: "form-control"
}
const _hoisted_20 = { class: "form-group col-md-4" }
const _hoisted_21 = {
  key: 0,
  class: "form-control"
}
const _hoisted_22 = { class: "form-group col-md-4" }
const _hoisted_23 = {
  key: 0,
  class: "form-control"
}
const _hoisted_24 = { class: "form-group col-md-4" }
const _hoisted_25 = {
  key: 0,
  class: "form-control"
}
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "form-group col-md-4" }
const _hoisted_28 = {
  key: 0,
  class: "form-control"
}
const _hoisted_29 = { class: "form-group col-md-8" }
const _hoisted_30 = {
  key: 0,
  class: "form-control"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_toggler = _resolveComponent("toggler")!
  const _component_op_date = _resolveComponent("op-date")!
  const _component_op_address = _resolveComponent("op-address")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Nome (fatturazione)",
              text: "Nome (fatturazione)"
            })
          ]),
          (_ctx.readonly)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.localValue.name), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.name) = $event))
              }, null, 512)), [
                [_vModelText, _ctx.localValue.name]
              ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Cognome (fatturazione)",
              text: "Cognome (fatturazione)"
            })
          ]),
          (_ctx.readonly)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.localValue.surname), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.surname) = $event))
              }, null, 512)), [
                [_vModelText, _ctx.localValue.surname]
              ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Sesso",
          text: "Sesso"
        })
      ]),
      (_ctx.readonly)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.localValue.sex), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-link", { active: _ctx.localValue.sex == 'M'}]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.localValue.sex = 'M'))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Maschio",
                text: "Maschio"
              })
            ], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-link", { active: _ctx.localValue.sex == 'F'}]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.localValue.sex = 'F'))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Femmina",
                text: "Femmina"
              })
            ], 2)
          ]))
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Codice Fiscale",
              text: "Codice Fiscale"
            })
          ]),
          (_ctx.readonly)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.localValue.fiscalCode), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localValue.fiscalCode) = $event))
              }, null, 512)), [
                [_vModelText, _ctx.localValue.fiscalCode]
              ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Partita iva",
              text: "Partita iva"
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_toggler, {
              readonly: _ctx.readonly,
              modelValue: _ctx.localValue.hasVat,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localValue.hasVat) = $event))
            }, null, 8, ["readonly", "modelValue"])
          ])
        ])
      ])
    ]),
    (_ctx.localValue.hasVat)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Ragione sociale",
                text: "Ragione sociale"
              })
            ]),
            (_ctx.readonly)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.localValue.companyName), 1))
              : _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localValue.companyName) = $event))
                }, null, 512)), [
                  [_vModelText, _ctx.localValue.companyName]
                ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Numero partita iva",
                text: "Numero partita iva"
              })
            ]),
            (_ctx.readonly)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.localValue.vatNumber), 1))
              : _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localValue.vatNumber) = $event))
                }, null, 512)), [
                  [_vModelText, _ctx.localValue.vatNumber]
                ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Codice destinatario",
                text: "Codice destinatario"
              })
            ]),
            (_ctx.readonly)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.localValue.codiceDestinatario), 1))
              : _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localValue.codiceDestinatario) = $event))
                }, null, 512)), [
                  [_vModelText, _ctx.localValue.codiceDestinatario]
                ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Pec",
                text: "Pec"
              })
            ]),
            (_ctx.readonly)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.localValue.pec), 1))
              : _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localValue.pec) = $event))
                }, null, 512)), [
                  [_vModelText, _ctx.localValue.pec]
                ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Data di nascita",
            text: "Data di nascita"
          })
        ]),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$filters.date(_ctx.localValue.birthDate)), 1))
          : (_openBlock(), _createBlock(_component_op_date, {
              key: 1,
              class: "form-control",
              modelValue: _ctx.localValue.birthDate,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.localValue.birthDate) = $event))
            }, null, 8, ["modelValue"]))
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Luogo nascita",
            text: "Luogo nascita"
          })
        ]),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.localValue.birthPlace), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.localValue.birthPlace) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.birthPlace]
            ])
      ])
    ]),
    _createVNode(_component_op_address, {
      readonly: _ctx.readonly,
      modelValue: _ctx.localValue.fiscalAddress,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.localValue.fiscalAddress) = $event)),
      label: _ctx.$localizationService.GetLocalizedValue('Indirizzo di fatturazione', 'Indirizzo di fatturazione')
    }, null, 8, ["readonly", "modelValue", "label"])
  ]))
}